(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("WebinarPreviewCtrl", ["$scope", webinarPreviewCtrl]);
    function webinarPreviewCtrl($scope) {
        var vm = this;
        vm.webinarType = $scope.$parent.vm.assignment.specificInfo.webinarTypeId;
        vm.recordings = $scope.$parent.vm.assignment.specificInfo.archiveDetails;
        $scope.$parent.vm.buttons = [];
        $scope.$parent.vm.haveMultipleButtons = true;
        if (vm.webinarType === 1)
            $scope.$parent.vm.buttons.push("selectWebinarButton");
        if (vm.recordings.length > 0)
            $scope.$parent.vm.buttons.push("viewRecordingsButton");
    }
}());
